import {
  ApiUtility,
  IApiListResult,
  IApiResponse,
} from "../../Utilities/ApiUtility.axios";
import { IIdNameModel } from "./ItemsService";
export interface IFALocation {
  locationName: string;
  id: string;
  subUnitId?: string;
  subUnitName?: string;
}
export interface IFALocationList extends IFALocation {
  sno?: number;
}

class AssetLocationService {
  route = `V1/API/Billing/Acc_FALocation`;

  getLocationList = (
    companyId: string | undefined,
    start?: number,
    length?: number,
    search?: string
  ) =>
    ApiUtility.get<IApiResponse<IFALocationList[]>>(
      `${this.route}/${companyId}/GetFALocationList?start=${start}&length=${length}&search=${search}`
    );

  getLocationDatabyId = (companyId: string | undefined, FALocationId: string) =>
    ApiUtility.get<IApiResponse<IFALocation>>(
      `${this.route}/${companyId}/${FALocationId}`
    );

  deleteLocationDatabyId = (
    companyId: string | undefined,
    FALocationId: string
  ) => ApiUtility.delete(`${this.route}/${companyId}/${FALocationId}`);

  postLocationData = (
    companyId: string | undefined,
    modal: any,
    FALocationId?: string
  ) =>
    ApiUtility.post<IApiResponse<IFALocation>>(
      `${this.route}/${companyId}/${FALocationId ? FALocationId : ""}`,
      modal
    );
}
export default new AssetLocationService();
